import {Outlet} from "react-router-dom";
import React from "react";


function RatesBase() {
    return (
        <Outlet/>
    )

}

export default RatesBase;